<template>
  <div>
    <catalog-multi-select
      ref="catalog_select"
      catalog-name="категории"
      :is-disabled="isDisabled"
      :initial-value="value"
      :get-list="getItems"
      :can-create-catalog="canEditDriverLicenseCategory()"
      :drop-up="dropUp"
      @onSelect="$emit('input', $event)"
      @open-modal="isModalVisible = true"
    />

    <driver-license-category
      v-if="isModalVisible"
      :exact-id="0"
      @modal-closed="isModalVisible = false"
      @refresh="onCatalogItemCreated"
    />
  </div>
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, { PERM } from "../../../utilites/permissions";
    import CatalogMultiSelect from "../CatalogMultiSelect.vue";
    import DriverLicenseCategory from "./DriverLicenseCategory.vue";

export default {
  name: "EmploymentCategoriesMultiSelect",
  components: { DriverLicenseCategory, CatalogMultiSelect },
  mixins: [
    catalogs,
    permissions
  ],
  props: {
    isDisabled: { type: Boolean, default: false },
    value: { type: Array, default: () => [] },
    dropUp: { type: Boolean, default: false }
  },
  data() {
    return {
      isModalVisible: false
    };
  },
  methods: {
    async getItems() {
      const result = await this.getDriverLicenseCategoriesSearch("");
      return (result && result.data) ? result.data : [];
    },
    async onCatalogItemCreated(newItem) {
      this.$refs.catalog_select.onItemCreated(newItem);
      this.$emit('catalog-created', newItem);
      this.isModalVisible = false;
    },
    // Permissions
    canEditDriverLicenseCategory(item) {
      return this.hasPermission([PERM.CATALOG_DRIVER_LICENSE_CATEGORY_EDIT]);
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/DriverLicenseCategories/DriverLicenseCategoriesMultiSelect.vue